<template>
  <div class="videos bg-white h-full">

    <FilterBar @searchChanged="setSearchValue">
      <template v-slot:filter>
        <div>
        </div>
        <div>

        </div>
      </template>
    </FilterBar>

    <div v-if="errored" class="empty">
      <p>
        We are not able to retrieve this information at the moment, please try
        back later
      </p>
    </div>

    <div id="content-area" v-else>
      <div
        style="width: 100%; text-align: center"
        class="spin-holder mt-4"
        v-if="loading"
      >
        <i class="spinner fa fa-spinner fa-spin"></i>
        <p>Loading Videos</p>
      </div>

      <div v-else>
        <table
          class="
            w-95p
            mx-auto
            mb-2
            h-10
            pt-2
            align-text-bottom
            bg-white
            rounded
            text-left text-gray-600
          "
        >
          <thead class="bg-gray-100 w-full">
            <tr>
              <th class="w-2/12 px-3">Type</th>
              <th class="w-5/12 pl-3">Title</th>
              <th class="w-4/12 pl-3">Tags</th>
              <th w-1>Action</th>
            </tr>
          </thead>
        </table>

        <table class="table-wrapper w-95p bg-white mx-auto rounded shadow-sm">
          <tbody>
            <tr v-for="video in filteredList" :key="video.id">
              <td class="w-2/12 pr-3 capitalize">{{ parseTypeDisplay(video.display_key) }}</td>
              <td class="w-5/12 font-semibold">{{ video.title }}</td>
              <td class="w-4/12">{{ video.tags }}</td>
              <td class="2u">
                <a
                  @click="display(video)"
                  class="button special small cursor-pointer"
                  >View</a
                >
              </td>
            </tr>
          </tbody>
        </table>

        <div class="m-4 text-gray-500 pt-2 pl-5">
          Showing {{ filteredList.length }} videos
        </div>
      </div>
    </div>

    <modalvideo
      :url="loadVideoPath()"
      @close="showModalVideo = false"
      v-if="selectedVideo != undefined && showModalVideo"
      v-show="showModalVideo"
    ></modalvideo>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { BaseService } from "@/services/school.service";

const modalvideo = () => import("@/components/ModalVideo.vue");
const FilterBar = () => import("@/components/FilterBarNavigation.vue");

export default {
  name: "videos",
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    componentLoaded() {
      return this.videos.length > 0;
    },
    orderedVideos() {
      return _.orderBy(this.videos, ["title"]);
    },
    filteredList() {
      var vm = this;
      return this.orderedVideos.filter((item) => {
        let filtered = true;
        if (item.tags != null) {
          filtered = item.tags.toLowerCase().includes(vm.search.toLowerCase());
        }

        if (filtered) {
          if (item.title != null) {
            filtered = item.title
              .toLowerCase()
              .includes(vm.search.toLowerCase());
          }
        }

        return filtered;
      });
    },
  },
  data() {
    return {
      loading: true,
      errored: false,
      videos: [],
      selectedVideo: {},
      showModalVideo: false,
      search: "",
      videoType: "",
      currentTab: 0,
    };
  },
  created() {
    this.videoType = { value: "swimming", name: "Swimming" }
    this.fetchData();
  },
  mounted() {
  },
  methods: {
    fetchData() {
      this.loading = true;

      BaseService.getAll("videos?types=library&tags=" + this.videoType.value)
        .then((response) => this.buildVideoList(response.data.data))
        .catch((err) => {
          console.log("Videos " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    buildVideoList(data) {
      this.videos = data;
    },
    display(video) {
      this.selectedVideo = video;
      this.showModalVideo = true;
    },
    loadVideoPath() {
      return this.selectedVideo.service_url_b;
    },
    setStyles(value) {
      return this.vid === value
        ? "bg-orange-300 text-white"
        : "bg-white text-gray-400";
    },
    checkTab(value) {
      return this.currentTab == value ? "active" : "";
    },
    showVideos(tab, cat) {
      this.typeSelected = "videos";
      this.currentTab = tab;
      this.videoType = cat;
    },
    updateVideoType(value) {
      this.videoType = value;
      this.fetchData()
    },
    setSearchValue(value) {
      this.search = value
    },
    parseTypeDisplay(value) {
      return value.toLowerCase()
    }
  },
  components: {
    modalvideo,
    FilterBar,
  },
};
</script>

<style>
i.icon {
  font-size: 18px;
  padding-left: 4px;
  padding-top: 4px;
}
</style>
